import { FallbackProps } from 'react-error-boundary';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { getErrorInfoFromStatusCode } from 'src/utils/errorUtils';

import { SomethingWentWrong } from './SomethingWentWrong';

export const RootErrorPage = (props: FallbackProps) => {
  const routeError = useRouteError();
  const error = routeError ?? props.error;

  const message = ((error ?? {}) as { message?: string }).message;
  const status = isRouteErrorResponse(error) ? error.status : undefined;
  const statusText = isRouteErrorResponse(error) ? error.statusText : undefined;

  const { headerDisplay, messageDisplay } = status
    ? getErrorInfoFromStatusCode(status, statusText)
    : { headerDisplay: undefined, messageDisplay: undefined };

  return (
    <SomethingWentWrong
      header={headerDisplay}
      message={messageDisplay}
      messages={[message]}
    />
  );
};
